export default __webpack_public_path__ + "static/media/project-wizard-questionnaires_dark.ad2d24b2.png";